import { render, staticRenderFns } from "./s-form-checkbox.vue?vue&type=template&id=0002ea46"
import script from "./s-form-checkbox.vue?vue&type=script&lang=js"
export * from "./s-form-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports